import React from "react";
import { SpecialistRegistor } from "~/screens/specialist/registor";

export const SpecialistHome: React.VFC = () => {
  return <SpecialistRegistor type="update" />;
};
